import { formatTime } from '@/lib/format';
import { useRealtime } from '@/stores/realtime';

export function ActivityPage() {
  const events = useRealtime((s) => s.events);

  return (
    <>
      <div className="page-head">
        <h1>Activity</h1>
        <p>
          Everything received on the realtime stream since you signed in. Stored activity logs from
          the server arrive with the market data and trading phases.
        </p>
      </div>

      <section className="panel">
        <div className="panel-body flush">
          {events.length === 0 ? (
            <div className="empty">Nothing yet.</div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Channel</th>
                  <th>Event</th>
                  <th className="right">Seq</th>
                  <th>Payload</th>
                </tr>
              </thead>
              <tbody>
                {events.map((event) => (
                  <tr key={`${event.channel}-${event.seq}`}>
                    <td className="num">{formatTime(event.ts)}</td>
                    <td>{event.channel}</td>
                    <td>{event.event}</td>
                    <td className="right num">{event.seq}</td>
                    <td className="num" style={{ color: 'var(--text-secondary)' }}>
                      {JSON.stringify(event.data)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </section>
    </>
  );
}
